export default "__VITE_ASSET__67e342c9__$_?nuxt_component=async&nuxt_component_name=SvgoGgBg1__"